<template>
  <div 
    v-show="(paquete === 2 || paquete === 3 || paquete === 4) && welcomeText"
    ref="bienvenidaRef"
    class="bienvenida-overlay"
  >
    <div ref="contenidoRef" class="overlay-content">
      <!-- Franja superior con ornamento y rama debajo -->
      <div class="franja-superior">
        <div class="decoracion-wrapper">
          <!-- LA RAMA: Ahora con z-index inferior y posición ajustada -->
          <img ref="ramaRef" src="@/assets/monio.png" alt="rama" class="rama-decorativa" />
          <!-- LA FLOR: Al frente -->
          <img ref="ornamentoArriba" src="@/assets/fl.png" alt="ornamento" class="ornamento-arriba" />
        </div>
        <span ref="tituloRef" class="titulo-pase">Apreciable</span>
      </div>
      
      <!-- Nombre del invitado -->
      <div ref="textoRef" class="welcome-text">
        {{ welcomeText }}
      </div>

      <!-- Mensaje de bienvenida -->
      <div ref="mensajeRef" class="mensaje-bienvenida">
        Para nosotros sería un honor contar con tu presencia en este día tan especial donde celebro mis XV.
        <br><br>
      </div>

      <!-- Info -->
      <div class="info-container">
        <div v-if="(paquete === 3 || paquete === 4) && numpase" ref="paseRef" class="info-item">
          <i class="fas fa-ticket-alt"></i>
        </div>
        <div v-if="paquete === 4 && mesaText" ref="mesaRef" class="info-item">
          <i class="fas fa-circle"></i>
        </div>
      </div>
    </div>

   
  </div>
</template>

<script>
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import axios from 'axios';
import baseUrl from '@/api';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'InvitadoEvento',
  props: {
    idInvitado: Number,
    nombre: String,
    idFestejado: Number
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const contenidoRef = ref(null);
    const tituloRef = ref(null);
    const textoRef = ref(null);
    const mensajeRef = ref(null);
    const paseRef = ref(null);
    const mesaRef = ref(null);
    const tooltipRef = ref(null);
    const ornamentoArriba = ref(null);
    const ramaRef = ref(null);

    const welcomeText = ref('');
    const mesaText = ref('');
    const numpase = ref(null);
    const paquete = ref(null);
    const showTooltip = ref(false);
    let tooltipTimeout;

    const fetchData = async () => {
      if (!isNaN(props.idInvitado) && props.idInvitado > 0) {
        try {
          const url = `${baseUrl}/${props.nombre || ''}/${props.idFestejado || ''}/${props.idInvitado}`;
          const response = await axios.get(url);
          welcomeText.value = response.data.nombre_mostrar;
          mesaText.value = response.data.num_mesa;
          numpase.value = response.data.num_pase;
          paquete.value = response.data.paquete;
        } catch (err) {
          console.error('Error al obtener los datos', err);
        }
      }
    };

    const animateElements = () => {
      const tl = gsap.timeline();

      // Estado inicial: Rama escondida justo detrás del centro de la flor
      gsap.set(ramaRef.value, { scale: 0.2, opacity: 0, transformOrigin: "50% 20%" });

      // 1. Flor aparece girando
      tl.fromTo(ornamentoArriba.value, { rotation: 0, scale: 0, opacity: 0 }, {
        rotation: 360,
        scale: 1,
        opacity: 0.9,
        duration: 1.2,
        ease: 'power2.out'
      });

      // 2. Rama nace y "cae" suavemente hacia abajo/atrás
      tl.to(ramaRef.value, {
        scale: 1.1,
        opacity: 0.7,
        y: 10, // Cae un poquito hacia abajo
        duration: 1.8,
        ease: "power1.out"
      }, "-=0.6");

      tl.fromTo(tituloRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 }, "-=1.2");
      tl.fromTo(textoRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 }, "-=0.8");
      tl.fromTo(mensajeRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 }, "-=0.8");
      tl.fromTo([paseRef.value, mesaRef.value], { opacity: 0, y: 15 }, { opacity: 1, y: 0, duration: 0.8 }, "-=0.8");

      gsap.fromTo(tooltipRef.value, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1.5, ease: "sine.inOut" });
    };

    const resetElements = () => {
      gsap.set([tituloRef.value, textoRef.value, mensajeRef.value, paseRef.value, mesaRef.value], { opacity: 0, y: 20 });
      gsap.set(ornamentoArriba.value, { rotation: 0, opacity: 0, scale: 0 });
      gsap.set(ramaRef.value, { scale: 0.2, opacity: 0 });
      gsap.set(tooltipRef.value, { opacity: 0 });
    };

    onMounted(async () => {
      await fetchData();
      await nextTick();

      ScrollTrigger.create({
        trigger: bienvenidaRef.value,
        start: 'top 85%',
        onEnter: () => {
          showTooltip.value = true;
          animateElements();
        },
        onLeaveBack: () => {
          showTooltip.value = false;
          resetElements();
        }
      });
    });

    onBeforeUnmount(() => clearTimeout(tooltipTimeout));

    return {
      bienvenidaRef, contenidoRef, tituloRef, textoRef, mensajeRef,
      paseRef, mesaRef, tooltipRef, ornamentoArriba, ramaRef,
      welcomeText, mesaText, numpase, paquete, showTooltip
    };
  }
};
</script>

<style scoped>
.bienvenida-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 50vh;
  padding: 10px;
}

.overlay-content {
  padding: 30px;
  text-align: center;
  width: 450px;
  position: relative;
}

/* CONTENEDOR DECORATIVO */
.decoracion-wrapper {
  position: absolute;
  right: -40px;
  top: -10px;
  width: 120px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* LA RAMA: Debajo de la flor y más etérea */
.rama-decorativa {
  position: absolute;
  width: 0% !important; 
  height: auto;
  z-index: 1; /* Atrás */
  top: -30px; /* La bajamos para que cuelgue de la flor */
  filter: brightness(1.1) opacity(0.9);
}

/* LA FLOR: Al frente */
.ornamento-arriba {
  position: relative;
  width: 0px !important;
  height: auto;
  z-index: 2; /* Adelante */
}

.titulo-pase {
  font-family: 'ludovica', cursive;
  font-size: 42px !important;
background: linear-gradient(
  110deg,
  #f0c9d3 30%,
  #f0c9d3 45%,
  #f0c9d3 50%,
  #f0c9d3 55%,
  #f0c9d3 70%
);  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  display: block; 
}

.welcome-text {
  font-size: 1.4rem;
  font-family: 'quote', serif;
  color: #1a1a1a;
  margin: 15px 0 10px;
}

.mensaje-bienvenida {
  font-size: 1rem;
  font-family: 'padres';
  color: #050505;
}

.info-container {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  color: #171717;
  font-family: 'padres';
}

.tooltip {
  position: absolute;
  bottom: 0px;
  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  color: white;
  padding: 5px 15px;
  width: 0 !important;
  border-radius: 8px;
  font-size: 14px;
  opacity: 0;
  width: 0 !important;
}
</style>